import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: true,
  template: `
    <div class="form-control-group">
      <div class="filter-form__range">
        <label style="margin-top: 6px;" class="label">{{ props.label }}</label>
        <ng-container class="filter-form__inputs" #fieldComponent></ng-container>
      </div>
    </div>
  `,
})
export class IntervalWrapperComponent extends FieldWrapper {
}
